import { displayStatevz5dnqm1uehi as displayState } from '../../../../crowpay-shared/com/crowpay/statePermissions.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function displayState_0(_this__u8e3s4) {
  return displayState(_this__u8e3s4.hf9_1);
}
//region block: exports
export {
  displayState_0 as displayState3t6e3fm84zv10,
};
//endregion

//# sourceMappingURL=LineItem.ext.mjs.map
